// All site text lives here. Edit copy in this one file.
export const CONTENT = {
  siteName: "ONE SHARE",
  stickyTop: "Pray, Share and Let It Ripple.",
  nav: [
    { label: "Home", to: "/" },
    { label: "The Heart Behind ONE SHARE", to: "/the-heart-behind-one-share" },
    { label: "Library", to: "/library" },
    { label: "Prayer Request", to: "/prayer-request" },
  ],
  authNav: {
    login: { label: "Log in", to: "/account" },
    myShares: { label: "My Shares", to: "/my-shares" },
    logout: "Log out",
    admin: { label: "Admin", to: "/admin" },
  },
  logoAlt: "ONE SHARE logo",
  menuLabel: "Menu",
  closeMenuLabel: "Close",
  footer: {
    signOff: "Pray. Share. Let It Ripple.",
    links: [
      { label: "Privacy Policy and Terms of Use", to: "/legal", testId: "footer-legal-link" },
      { label: "Contact us", to: "/contact", testId: "footer-contact-link" },
    ],
    copyright: (year) => `\u00a9 ${year} ONE SHARE. All rights reserved.`,
  },
  home: {
    wordOfDay: { label: "Word of the day", more: "Read the full word" },
    hero: {
      headline: "Your One Share Can Change A Life.",
      supporting: "As someone’s one share changed mine.",
      buttons: [
        { label: "Use Your One Share", to: "/library", style: "primary" },
        { label: "Read my story", to: "/the-heart-behind-one-share", style: "ghost" },
      ],
    },
    // Will be replaced by the admin "Home story glimpse" setting later.
    storyGlimpse: {
      label: "Why this exists",
      title: "How one share rippled",
      lines: [
        "A friend I had never met shared one sermon video on Facebook.",
        "That one share brought me to Christ.",
      ],
      steps: [
        { date: "October 2024", title: "One video, shared", text: "An online friend from Nepal shared a Sunday sermon on Facebook. Out of curiosity, I watched it to the end.", image: { src: "/story-2.webp", alt: "Tapping play on a shared sermon video" } },
        { date: "Every Sunday", title: "Another, and another", text: "Bible stories filled my feed. I asked questions, and her answers always came with a little more from the Bible.", image: { src: "/story-3.webp", alt: "A feed full of Bible story videos" } },
        { date: "January 2025", title: "A first prayer", text: "The night before my first service, I asked Jesus to take my back pain away. Within two minutes, it was gone.", image: { src: "/story-5.webp", alt: "Praying through back pain" } },
        { date: "April 2025", title: "Baptized", text: "I found a church, met people who now feel like family, and was baptized.", image: { src: "/story-4.webp", alt: "Reading the Bible and finding a church nearby" } },
        { date: "April 2026", title: "Back where it began", text: "I shared my testimony in Nepal, in the church whose sermon first reached me, with my friend in the room.", image: { src: "/story-7.webp", alt: "Sharing my testimony in Nepal" } },
      ],
      linkLabel: "Read the full story",
      linkTo: "/the-heart-behind-one-share",
    },
    purpose: {
      label: "Why share",
      title: "Your part, and God’s part",
      intro: "She never preached to me. She just kept sharing. That is all a share asks of you.",
      parts: [
        { label: "Your part", title: "Sow the seed", text: "Share a verse, a sermon or a Bible story. Your phone can reach further than you think.", verse: { text: "He said to them, \u201cGo into all the world and preach the gospel to the whole creation.\u201d", reference: "Mark 16:15" } },
        { label: "God’s part", title: "Leave the rest to Him", text: "You may never see what your share does. Something shared years ago may be changing a heart today.", verse: { text: "I planted. Apollos watered. But God gave the increase.", reference: "1 Corinthians 3:6" } },
      ],
      note: "World English Bible",
    },
    howItWorks: {
      label: "One share, three steps",
      steps: [
        { title: "Pray", text: "Ask God who needs a word today." },
        { title: "Share", text: "Pick a verse from the library and pass it on in one tap." },
        { title: "Let It Ripple", text: "Keep sharing, keep praying, and keep trusting. May God's will be done." },
      ],
    },
    situations: {
      label: "For when you feel",
      title: "A word for real life",
      text: "Find content for what you or a friend are going through right now, then share it.",
      browseAll: "Browse the whole library",
    },
    cta: {
      line: "Find a word to share today.",
      buttonLabel: "Open the library",
      buttonTo: "/library",
    },
  },
  heart: {
    title: "THE HEART BEHIND ONE SHARE",
    intro: "Why this site exists, in one story.",
    sections: [
      {
        kicker: "WHERE I STARTED",
        title: "I did not know Jesus",
        panels: [
          {
            image: { src: "/story-1.webp", alt: "A young man sitting with his phone" },
            paragraphs: [
              "Hi, I am Prasad. I come from a non-Christian background.",
              "For most of my life, I did not believe a God was running this universe. I never knew Jesus, and I never knew His word.",
            ],
          },
        ],
      },
      {
        kicker: "ONE SHARE",
        title: "A video from a friend in Nepal",
        panels: [
          {
            image: { src: "/story-2.webp", alt: "Tapping play on a shared sermon video as a seed falls" },
            paragraphs: [
              "In October 2024, I was scrolling Facebook when I found a sermon video shared by an online friend from Nepal. It was from a recent Sunday service. Out of curiosity, I watched it to the end.",
            ],
          },
          {
            image: { src: "/story-3.webp", alt: "A feed full of Bible story videos" },
            paragraphs: [
              "The next Sunday, she shared another one. And another. Soon my feed was full of animated Bible stories: Moses and the Red Sea, David and Goliath, Noah and the ark.",
              "Those stories made me curious, so I started asking my friend questions. Her answers always came with a little more from the Bible.",
            ],
          },
        ],
        verse: {
          items: [{ text: "How then will they call on him in whom they have not believed? How will they believe in him whom they have not heard? How will they hear without a preacher?", reference: "Romans 10:14" }],
        },
      },
      {
        kicker: "A FIRST PRAYER",
        title: "Within two minutes",
        panels: [
          {
            image: { src: "/story-4.webp", alt: "Reading the Bible and finding a church nearby" },
            paragraphs: [
              "At the start of 2025, I began reading the Bible. First Matthew, then Mark. After a while, reading alone did not feel like enough. I wanted to be around people who were living what I was trying to understand.",
              "So I found a church near me and planned to attend my first Sunday service on 19 January 2025. But on the night before, I had severe lower back pain, and I did not think I could go.",
            ],
          },
          {
            image: { src: "/story-5.webp", alt: "Praying through back pain the night before the first service" },
            paragraphs: [
              "Then I remembered what my friend had told me: always ask God for guidance, healing and strength. I did not know how to pray properly, so I just said:",
            ],
            quote: "\u201cLook, Jesus, tomorrow I will be attending a Sunday service for the first time. If this pain persists, I will not be able to. Please do something about it.\u201d",
            highlight: "Within two minutes, the pain was gone.",
          },
        ],
        verse: {
          items: [{ text: "Ask, and it will be given you. Seek, and you will find. Knock, and it will be opened for you.", reference: "Matthew 7:7" }],
        },
      },
      {
        kicker: "WHAT HAPPENED NEXT",
        title: "All because of one share",
        panels: [
          {
            paragraphs: [
              "I attended the service. I met people who now feel like family. In April 2025, I was baptized.",
            ],
          },
          {
            image: { src: "/story-7.webp", alt: "Sharing my testimony in the church in Nepal whose sermon was shared with me" },
            paragraphs: [
              "On 12 April 2026, exactly one year after my baptism, I went to Nepal, to the same church whose Sunday sermon had first reached me on Facebook.",
              "There I shared my testimony. And my friend, the one who shared that first video, was in the room as I told it.",
              "All of this began because someone in another country thought of sharing one Sunday service video on Facebook.",
            ],
          },
        ],
      },
      {
        kicker: "YOUR TURN",
        title: "You can be that someone",
        panels: [
          {
            image: { src: "/story-6.webp", alt: "Sending a share onward like a paper plane" },
            paragraphs: [
              "You do not need to preach, and you do not need to create content. Share a verse, a sermon, a Bible story, anything you like. Sow the seed, and leave the rest to God.",
              "If you feel nervous that it might go badly, or that people will think you are pushing your beliefs, that feeling is valid. It does not have to stop you.",
              "And do not be discouraged if you do not see results. Something you shared years ago may be changing a heart today. Keep sharing, keep praying, and keep trusting.",
            ],
          },
        ],
        verse: {
          items: [{ text: "In the morning sow your seed, and in the evening don\u2019t withhold your hand: for you don\u2019t know which will prosper, whether this or that, or whether they will both be alike good.", reference: "Ecclesiastes 11:6" }],
        },
      },
      {
        kicker: "THE TRUE GOSPEL",
        title: "Share the peace, not the promises",
        panels: [
          {
            paragraphs: [
              "Social media is full of messages about the big house and the sports car you will get after coming to Jesus. That is not the gospel I met.",
              "Let us share the message of Jesus and the peace He gives, so that the real message is the one that is heard.",
            ],
          },
        ],
        verse: {
          items: [{ text: "Peace I leave with you. My peace I give to you; not as the world gives, give I to you. Don\u2019t let your heart be troubled, neither let it be fearful.", reference: "John 14:27" }],
          note: "World English Bible",
        },
      },
    ],
    closing: {
      signOff: "Pray. Share. Let It Ripple.",
      buttonLabel: "Open the library",
      buttonTo: "/library",
    },
  },
  auth: {
    tabs: { signUp: "Create account", signIn: "Log in" },
    legalPrefix: "By creating an account you agree to the ",
    legalLink: "Privacy Policy and Terms of Use",
    legalSuffix: ".",
    legalTo: "/legal",
  },
  admin: {
    title: "Admin",
    loading: "Loading…",
    notAllowed: "You do not have access to this page.",
    tabs: { content: "Content", users: "Users" },
    contentTitle: "Content manager",
    addContent: "Add content",
    newTitle: "New content",
    editTitle: "Edit content",
    empty: "No content yet. Add your first verse.",
    fields: {
      title: "Title",
      verse_text: "Verse text",
      verse_reference: "Verse reference",
      translation: "Bible translation",
      message: "Short message",
      image: "Image (optional)",
      embed_url: "Embed link (optional, e.g. YouTube)",
      category: "Category",
      publish_date: "Publish date",
      status: "Status",
    },
    categoryHint: "Type a new one or pick one",
    statusDraft: "Draft",
    statusPublished: "Published",
    statusScheduled: "Scheduled",
    statusLive: "Live",
    removeImage: "Remove image",
    uploading: "Uploading…",
    save: "Save",
    saving: "Saving…",
    saved: "Saved.",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    deleteTitle: "Delete this content?",
    deleted: "Deleted.",
    usersTitle: "Users",
    roleSaved: "Role updated.",
    roleNames: { admin: "Admin", user: "User" },
    menu: { content: "Content", prayer: "Prayer card", thankyou: "Thank-you screen", settings: "Settings", ripples: "Ripples", users: "Users" },
    newContent: "New content",
    searchPlaceholder: "Search by title",
    tagsLabel: "Tags (comma separated, e.g. Anxious, Grief)",
    embedHint: "Paste a YouTube or Vimeo link, or a Facebook video embed code.",
    embedPreview: "Preview",
    settingsSaved: "Saved.",
    upload: "Upload image",
    forms: {
      prayer: { title: "Prayer card", fields: [["title", "Title"], ["text", "Prayer text", true], ["close_label", "Close button label"]] },
      thankyou: { title: "Thank-you screen", fields: [["heading", "Heading"], ["message", "Message", true], ["button1", "Button 1 label"], ["button2", "Button 2 label"]] },
      settings: { title: "Settings", fields: [["story_glimpse", "Home story glimpse (one line per row)", true], ["share_message", "Default share message (use {title}, {reference}, {link})", true], ["form_submission_link", "Form submission link"]], imageField: ["share_image", "Default share image"], wordField: ["word_of_day", "Word of the day on the Home page", "Newest published word (automatic)"] },
    },
    ripples: { title: "Ripples", totalShares: "Total shares", totalReached: "Total people reached", byPlatform: "Shares by platform", top: "Most shared", none: "No shares yet." },
  },
  defaults: {
    prayer_card: {
      title: "Before you share, pray",
      text: "Lord, thank You for this word. Use this one share to reach the heart that needs it today. Go before it, open the way, and bring hope and peace. In Jesus' name, amen.",
      close_label: "Amen",
    },
    thank_you: {
      heading: "Thank you for choosing to share.",
      message: "May God use your one share mightily and more and more hearts come to Christ through you.",
      button1: "Sow another seed",
      button2: "Track your share",
    },
    site: {
      story_glimpse: "A friend I had never met shared one sermon video on Facebook.\nThat one share brought me to Christ.",
      share_message: "A word for you today: {title} ({reference}). {link}",
      share_image: "",
      word_of_day: "",
      form_submission_link: "",
    },
  },
  library: {
    label: "Library",
    title: "Gospel Content Library",
    supporting: "Find a word to share today.",
    searchPlaceholder: "Search a word, verse or situation",
    allLabel: "All",
    situationsLabel: "For when you feel",
    situationsHint: "Find content for what you are going through in real life.",
    videoPill: "Video",
    empty: "No words here yet. Please check back soon.",
    noResults: "Nothing matches that search. Try another word.",
    prev: "Previous",
    next: "Next",
    track: {
      signedOut: { label: "Track your ripple", title: "See how far your shares travel", text: "Create a free account and we will count how many people open the words you share.", primary: { label: "Create account", to: "/account" } },
      signedIn: { label: "Your ripple", title: "See how far your shares travel", text: "Every word you share from here is counted on your My Shares page. Praise God for every heart it reaches.", primary: { label: "My Shares", to: "/my-shares" } },
    },
  },
  contentView: {
    back: "Back to the library",
    notFound: "We could not find this word.",
    notFoundButton: "Back to the library",
  },
  share: {
    heading: "Share on",
    platforms: [["whatsapp", "WhatsApp"], ["facebook", "Facebook"], ["instagram", "Instagram"], ["threads", "Threads"], ["snapchat", "Snapchat"], ["x", "X"]],
    copyLink: "Copy link",
    copied: "Link copied",
    pasteIn: { instagram: "Link copied. Paste it in Instagram.", snapchat: "Link copied. Paste it in Snapchat." },
    prayerPill: "A prayer",
    closeAria: "Close",
  },
  myShares: {
    label: "My Shares",
    title: "Your ripple",
    supporting: "See how far your shares have travelled.",
    stats: ["Shares", "People reached", "Platforms used"],
    byPlatform: "By platform",
    whatIShared: "What I shared",
    reachedWord: "people reached",
    reachedOne: "person reached",
    sharesWord: "shares",
    shareOne: "share",
    on: "on",
    empty: "You have not shared anything yet. Open the library to sow your first seed.",
    emptyButton: "Open the library",
    prev: "Previous",
    next: "Next",
  },
  prayerRequest: {
    label: "Prayer Request",
    title: "Send us a prayer request",
    supporting: "We would be honored to pray with you.",
    anonPill: "Anonymous by default",
    anonNotice: "This form is anonymous by default. We do not ask for your email or any personal details. Adding your name is optional, and only if you would like us to pray for you by name.",
    requestLabel: "Your prayer request",
    requestPlaceholder: "Share what is on your heart. Keep it as short or as long as you like.",
    nameLabel: "Your name (optional)",
    namePlaceholder: "Your name",
    nameHelper: "Only add this if you would like us to pray for you by name. Leave it empty to stay anonymous.",
    submit: "Send my request",
    sending: "Sending...",
    note: "Please do not include private details about other people. This is not an emergency service. If you or someone else is in danger, please contact your local emergency services.",
    validation: "Please write your prayer request.",
    error: "Something went wrong. Please try again in a moment.",
    notReady: "The prayer request form is not ready yet. Please check back soon.",
    successHeading: "Thank you.",
    successAnon: "Your request has been received, anonymously, and we will be praying for you.",
    successNamed: "Your request has been received, and we will be praying for you by name.",
    again: "Send another request",
    library: "Open the library",
  },
  contact: {
    label: "Contact us",
    title: "Contact us",
    supporting: "Questions, or a request about your information? We are here to help.",
    nameLabel: "Name",
    emailLabel: "Email",
    typeLabel: "Request type",
    detailsLabel: "Details",
    namePlaceholder: "Your name",
    emailPlaceholder: "you@example.com",
    emailHelper: "If your question is about your account, use the email address on your account.",
    detailsPlaceholder: "Write your message here.",
    types: ["Question", "Show my information", "Correct my information", "Delete my account", "Other"],
    submit: "Send message",
    sending: "Sending...",
    validation: "Please fill in all fields with a valid email.",
    error: "Something went wrong. Please try again in a moment.",
    notReady: "The contact form is not ready yet. Please check back soon.",
    successHeading: "Thank you.",
    successMessage: "Your message has been received. We will respond within 30 days.",
    again: "Send another message",
    library: "Open the library",
  },
  legal: {
    pageTitle: "Privacy Policy and Terms of Use",
    contactButton: "Contact us",
    contactTo: "/contact",
    label: "Legal",
    title: "Privacy Policy and Terms of Use",
    sections: [
      {
        title: "Privacy policy",
        paragraphs: [
          "Accounts: if you create an account, we keep your email address, your name if you give it, and your sign-in details so you can log in and see your shares. Sign-in is handled by a secure sign-in service. You can sign up with Google or with an email and password.",
          "Share tracking: when you share a word through a share button, we record which word you shared, the platform you chose and the time. If you are not logged in, this is linked to a random id kept in your browser, and moved to your account when you log in. We can only record that a share button was tapped, not whether anything was posted.",
          "People reached: when someone opens a shared link, we count one visit per browser. We do not store any personal data about the people who open your links.",
          "Prayer requests and contact messages: these are sent from the forms on this site to a private Google Sheet in the site owner's Google account. They are not stored on this site. The prayer request form is anonymous by default, and your name is only included if you choose to add it. Google's own privacy policy applies to that sheet.",
          "We do not sell your data, we do not send newsletters and we do not show ads.",
        ],
      },
      {
        title: "Terms of use",
        paragraphs: [
          "ONE SHARE is a free tool to help you read and share gospel content. Please use it kindly and respectfully.",
          "Bible verses are from the translation shown with each word. Videos come from their original platforms, and their terms apply.",
          "We may update the content and features of this site at any time. If you have a question, please use the Contact us page to reach us.",
        ],
      },
    ],
  },
  placeholders: {},
};
